<template>
  <div class="relative z-10" ref="wrapper">
    <img
      @click="open = !open"
      :class="['rounded-full cursor-pointer', avatarClass]"
      :src="photo"
      alt="Profile"
    />
    <div
      v-if="open"
      :class="[
        'absolute right-0 mt-2 bg-white rounded-lg shadow-lg border border-gray-200',
        menuClass,
      ]"
    >
      <ul class="py-2 text-sm text-left">
        <li @click="goToProfile" class="px-4 py-2 hover:bg-gray-100 cursor-pointer">
          Edit Profile
        </li>
        <li @click="logOut" class="px-4 py-2 hover:bg-gray-100 cursor-pointer">
          Log Out
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { computed, ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { auth } from "@/firebase/firebaseConfig.js";

const PLACEHOLDER_AVATAR = "https://via.placeholder.com/40x40";

// Avatar del usuario con menú desplegable (Edit Profile / Log Out).
export default {
  props: {
    avatarClass: { type: String, default: "w-10 h-10" },
    menuClass: { type: String, default: "w-40" },
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const open = ref(false);
    const wrapper = ref(null);

    const photo = computed(() => store.state.user?.photo || PLACEHOLDER_AVATAR);

    const goToProfile = () => {
      open.value = false;
      router.push({
        name: "edit-resource",
        params: { id: auth.currentUser?.uid, profile: true },
      });
    };

    const logOut = async () => {
      open.value = false;
      if (store.state.loggedUser) {
        await store.dispatch("logOut");
      }
      router.push({ name: "login" });
    };

    const handleClickOutside = (event) => {
      if (wrapper.value && !wrapper.value.contains(event.target)) {
        open.value = false;
      }
    };

    onMounted(() => document.addEventListener("click", handleClickOutside));
    onBeforeUnmount(() =>
      document.removeEventListener("click", handleClickOutside)
    );

    return { open, wrapper, photo, goToProfile, logOut };
  },
};
</script>
